import type { ICashCheckSavedScalePackage } from "../../models/order/cash-check";

export const normalizeSavedScalePackage = (
  savedPackage: string | ICashCheckSavedScalePackage,
): ICashCheckSavedScalePackage =>
  typeof savedPackage === "string" ? { barcode: savedPackage } : savedPackage;
